import { render, staticRenderFns } from "./ss-article-list.vue?vue&type=template&id=2d9447d6&scoped=true&"
import script from "./ss-article-list.vue?vue&type=script&lang=js&"
export * from "./ss-article-list.vue?vue&type=script&lang=js&"
import style0 from "./ss-article-list.vue?vue&type=style&index=0&id=2d9447d6&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9447d6",
  null
  
)

export default component.exports